
import { defineComponent, ref, computed } from 'vue';
import { nameToHexColor } from 'name-to-hex-color';
import Color from '@/components/Color.vue';
import Links from '@/components/Links.vue';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const makeColor = require('color');

const DEFAULT_NAME = 'Bender Bending Rodríguez';

export default defineComponent({
  name: 'App',

  components: {
    Links,
    Color
  },

  setup() {
    const name = ref(DEFAULT_NAME);
    const color = computed(() => nameToHexColor(name.value));
    const letter = computed(() => name.value.slice(0, 1).toUpperCase());
    const bgColor = computed(() => makeColor(color.value).darken(0.5));

    return {
      name,
      color,
      letter,
      bgColor
    };
  }
});
